import InventoryType from '@/Enums/InventoryType.enum';
import { useEffect, useMemo, useState } from 'react';

export interface IInventoryTab {
  type: InventoryType;
  label: string;
  count?: number;
}

interface IParams {
  productId?: number | string | null;
  publishersCount: number;
  hasDomains: boolean;
  domainsCount?: number;
}

// Publishers come first so Custom List checkboxes stay the default view for products that have both.
const useInventoryTabs = ({ productId, publishersCount, hasDomains, domainsCount }: IParams) => {
  const [selectedTab, setSelectedTab] = useState<InventoryType | null>(null);

  useEffect(() => {
    setSelectedTab(null);
  }, [productId]);

  const tabs = useMemo(() => {
    const available: IInventoryTab[] = [];
    if (publishersCount) {
      available.push({ type: InventoryType.Publishers, label: 'Publishers', count: publishersCount });
    }
    if (hasDomains) {
      available.push({ type: InventoryType.Domains, label: 'Domains', count: domainsCount || undefined });
    }
    return available;
  }, [publishersCount, hasDomains, domainsCount]);

  const activeTab = tabs.find(tab => tab.type === selectedTab)?.type ?? tabs[0]?.type ?? InventoryType.Publishers;

  return { tabs, activeTab, setActiveTab: setSelectedTab };
};

export default useInventoryTabs;
